export { default, useDefaultProps } from './DefaultPropsProvider';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/DefaultPropsProvider/index.js
// module id = 8
// module chunks = 22